// extracted by mini-css-extract-plugin
module.exports = {"listItem":"Amenities-module__listItem___2ZhCD","list":"Amenities-module__list___2VFxt"};